import { useState } from "react";
import { Controller, Control } from "react-hook-form";
import "./style.scss";
import OliverText, { TextType } from "@builder/components/general/OliverText";

interface FormImageInputProps {
    name: string;
    control: Control<any>;
    rules?: object;
    defaultValue?: string;
}

const FormImageInput = ({ name, control, rules, defaultValue }: FormImageInputProps) => {
    const [preview, setPreview] = useState<string | null>(defaultValue || null);

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field: { onChange }, fieldState: { error } }) => (
                <div className="form-image-input">
                    <input
                        type="file"
                        id={name}
                        accept="image/*"
                        className="hidden-input"
                        onChange={e => {
                            const files = Array.from(e.target.files || []);
                            onChange(files); // Update form state
                            if (files.length > 0) {
                                setPreview(URL.createObjectURL(files[0]));
                            }
                        }}
                    />
                    <label htmlFor={name} className="custom-image-input">
                        {!preview && (
                            <>
                                <img src="./cloud-upload-icon.svg" alt="" />
                                <OliverText text="Drag & drop here" type={TextType.DESCRIPTION} />
                                <OliverText text="or" type={TextType.DESCRIPTION} />
                                <div className="fake-button">
                                    <img src="./paperclip-icon.svg" alt="" />
                                    <OliverText text="Choose file" type={TextType.BUTTON_4} color="blue" />
                                </div>
                                <OliverText text="Maximum upload size: 512 KB" type={TextType.DESCRIPTION} />
                            </>
                        )}
                        {preview && <img src={preview} className="preview-image" />}
                    </label>

                    {error && <div className="form-error">
                        <img src="./error2.svg" alt="" />
                        <OliverText color="red" type={TextType.DESCRIPTION}>{error.message}</OliverText>
                    </div>}
                </div>
            )}
        />
    );
};

export default FormImageInput;
